import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import ApiUrls from '../config/ApiUrls';
import { ExchangeRateRange } from '../config/Constants';
import { replaceByObject } from '../utils/Urls';
import API from './Api';
import translate from '../language/translate';

export enum ExchangeRateSource {
  group = 'group',
  fixer = 'fixer',
  balancer = 'balancer',
}

export const sourceDescription = (source: ExchangeRateSource): string => {
  switch (source) {
    case ExchangeRateSource.group:
      return translate('Global.RECHARGER');
    case ExchangeRateSource.balancer:
      return translate('Global.BALANCER');
    case ExchangeRateSource.fixer:
      return translate('Global.FIXER');
    default:
      return source;
  }
};

export type ExchangeRatesResponse = {
  rates: { [key: string]: { [key: string]: ExchangeRateApiResponse } };
  date: string;
};

export type ExchangeRateApiResponse = {
  from: string,
  to: string,
  range: string,
  date: string,
  rate: number,
  source: string,
};

export class ExchangeRatesApi extends API {
  static getExchangeRates(groupId: number): Promise<ExchangeRateApiResponse[]> {
    return API.get(
      replaceByObject(ApiUrls.GroupExchangeRates, { groupId })
    ).then((response: AxiosResponse<ExchangeRateApiResponse[]>) => response.data);
  }

  static setExchangeRate(groupId: number, from: string, to: string, rate: number, range: ExchangeRateRange, date: DateTime, source: ExchangeRateSource): Promise<ExchangeRateApiResponse> {
    return API.post(
      replaceByObject(ApiUrls.GroupExchangeRates, { groupId }),
      {
        from,
        to,
        groupId,
        rate,
        range,
        source,
        date: date.toISODate(),
      }
    ).then((response: AxiosResponse<ExchangeRateApiResponse>) => response.data);
  }

  static deleteExchangeRate(groupId: number, from: string, to: string, date: DateTime, range: ExchangeRateRange, source: ExchangeRateSource): Promise<void> {
    return API.delete(
      replaceByObject(ApiUrls.GroupExchangeRates, { groupId }),
      {
        data: {
          from,
          to,
          groupId,
          date: date.toISODate(),
          range,
          source,
        },
      }
    ).then(() => {});
  }
}
